import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var quizDetailsRes;
export const quizDetailsTodo = createAsyncThunk('quizDetails', async (id) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'quiz/view_quiz_details',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "quiz_id": id,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return quizDetailsRes = res.data
    } catch (error) {
        return quizDetailsRes = error.response.data
    }
})


const quizDetailsSlice = createSlice({
    name: 'quizDetails',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(quizDetailsTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('quizDetails', state.data)
            }
        });
        builder.addCase(quizDetailsTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default quizDetailsSlice.reducer; 